import PDFObjectPlugin from "pdfobject-vue";

export default defineNuxtPlugin({
	name: "pdf-object",
	order: 1060,
	setup: (nuxtApp) => {
		nuxtApp.vueApp.use(PDFObjectPlugin);
	},
});
